import { EventType, EventMessage, AccountInfo } from "@azure/msal-browser";
import { useUserContext } from "../../contexts";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

export const MsalListener = () => {
	const { user, setUser, setAccount } = useUserContext();
	const { instance } = useMsal();

	const parseJwt = (token: string) => {
		const base64Url = token.split(".")[1];
		const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split("")
				.map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
				.join("")
		);
		return JSON.parse(jsonPayload);
	};

	const initializeUser = async (account: AccountInfo) => {
		const userRoles = parseJwt(account.idToken || "").roles;
		console.info("MsalListener", {
			name: account.name || "",
			username: account.username || "",
			roles: userRoles || [],
			clinics: []
		});
		setTimeout(() => {
			setAccount(account);
			setUser({
				name: account.name || "",
				username: account.username || "",
				roles: userRoles || [],
				clinics: []
			});
		}, 0);
	};
	// Default to using the first account if no account is active on page load
	useEffect(() => {
		const accounts = instance.getAllAccounts();
		if (accounts.length > 0) {
			const account = accounts[0] as AccountInfo;
			if (!instance.getActiveAccount()) {
				instance.setActiveAccount(account);
			}
			if (!user || user.username !== account.username) {
				initializeUser(account);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [instance, user]);

	// Listen for sign-in events and set active account
	useEffect(() => {
		const callbackId = instance.addEventCallback(
			async (event: EventMessage) => {
				if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload) {
					const account = (event.payload as any).account as AccountInfo;
					if (!instance.getActiveAccount()) {
						instance.setActiveAccount(account);
					}
					if (!user || user.username !== account.username) {
						await initializeUser(account);
					}
				}
			}
		);

		return () => {
			if (callbackId) {
				instance.removeEventCallback(callbackId);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [instance, user]);

	return <></>;
};
